import i18n from '@/locales/i18n'
import { ADMIN_CUSTOMERS_ROUTES } from '@/router/routes'
import type { RouteType } from '@rfc/rfc-components-library/types'

export const ADMIN_CUSTOMERS_LIST_ROUTE_NAME = 'adminCustomersList'
export const ADMIN_CUSTOMERS_DETAIL_ROUTE_NAME = 'adminCustomersDetail'

const routes: RouteType[] = [
    {
        path: ADMIN_CUSTOMERS_ROUTES.baseUrl,
        name: ADMIN_CUSTOMERS_LIST_ROUTE_NAME,
        component: () => import('@/views/AdminView/AdminCustomersView/AdminCustomersView.vue'),
        meta: {
            title: i18n.global.t('menu.adminCustomers'),
            authRequired: true
        }
    },
    {
        path: ADMIN_CUSTOMERS_ROUTES.detailUrl,
        name: ADMIN_CUSTOMERS_DETAIL_ROUTE_NAME,
        component: () => import('@/views/CustomersView/CustomerDetailView.vue'),
        meta: {
            title: i18n.global.t('menu.adminCustomers'),
            authRequired: true
        }
    }
]

export default routes
